import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import AutonomousAgents from '../components/AutonomousAgents';
import DemoVideo from '../components/DemoVideo';
import BackToOverview from '../components/BackToOverview';

const AutonomousPage: React.FC = () => {
  useRouteMeta('autonomous');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.autonomous.eyebrow}
        title={r.routes.autonomous.heroTitle}
        subtitle={r.routes.autonomous.heroSubtitle}
      />
      <AutonomousAgents />
      <DemoVideo />
      <BackToOverview />
    </>
  );
};

export default AutonomousPage;
